import MuiLinearProgress, {
  LinearProgressProps,
} from '@mui/material/LinearProgress';

function LinearProgress(props: LinearProgressProps) {
  return <MuiLinearProgress {...props} />;
}

export default LinearProgress;
